import * as React from 'react'

import { Button, DialogTrigger, useDialogState } from '../../components'
import PublishDialog from '../../modals/publish'
import ChartLayout from '../../models/chart_layout'

export function Publish({ model }: { model: ChartLayout }) {
  const dialog = useDialogState()

  return (
    <>
      <Button
        as={DialogTrigger}
        state={dialog}
        leftContent="publish"
        theme="headerItem"
        data-testid="chart-toolbar-publish"
        contentClass="hidden lg:flex"
        title="Publish chart"
      >
        Publish
      </Button>
      <PublishDialog state={dialog} layoutModel={model} />
    </>
  )
}
